export const isObjectEmpty = (obj: object) => Object.keys(obj).length === 0;

export const isNotBlank = (value: any) => value !== '' && value !== null && value !== undefined;

export const isBlank = (value: any) => !isNotBlank(value);

export const obj2Html = (obj: object, indent = 0) => {
  let html = '';

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const keyHtml = typeof obj[key] === 'object' ? obj2Html(obj[key], indent + 1) : obj[key];
      html += '<div class="ml-' + indent + '"><span class="text-muted">' + key + ':</span> ' + keyHtml + '</div>';
    }
  }

  return html;
};

export const isObject = (value: any): value is object => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

// mirrors ActiveRecord's #present? so that presence here means the same thing it means on the server
export const isValuePresent = <T>(value: T): boolean => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length > 0;
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  // every Numeric is present? in ruby, including 0 - which is why this is not a plain truthiness check
  if (typeof value === 'number') {
    return true;
  }

  return !!value;
};
